"use strict";

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formVisibilityHelper = _interopRequireDefault(require("../../utils/formVisibilityHelper"));

var _formTypes = require("../../types/formTypes");

var _layout = _interopRequireDefault(require("./layout"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var FormContainer = /*#__PURE__*/function (_react$PureComponent) {
  _inherits(FormContainer, _react$PureComponent);

  var _super = _createSuper(FormContainer);

  function FormContainer() {
    _classCallCheck(this, FormContainer);

    return _super.apply(this, arguments);
  }

  _createClass(FormContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          form = _this$props.form,
          fields = _this$props.fields,
          _this$props$disableAl = _this$props.disableAllFields,
          disableAllFields = _this$props$disableAl === void 0 ? false : _this$props$disableAl,
          _this$props$fieldValu = _this$props.fieldValues,
          fieldValues = _this$props$fieldValu === void 0 ? {} : _this$props$fieldValu,
          showTitle = _this$props.showTitle,
          account = _this$props.account,
          defaultMessages = _this$props.defaultMessages,
          components = _this$props.components,
          _this$props$formClass = _this$props.formClasses,
          formClasses = _this$props$formClass === void 0 ? {} : _this$props$formClass,
          _this$props$fieldClas = _this$props.fieldClasses,
          fieldClasses = _this$props$fieldClas === void 0 ? {} : _this$props$fieldClas,
          FieldComponent = _this$props.FieldComponent,
          replaceFieldNames = _this$props.replaceFieldNames,
          FeedbackIcon = _this$props.FeedbackIcon,
          fieldTypeProps = _this$props.fieldTypeProps,
          ignoreVisibility = _this$props.ignoreVisibility,
          _this$props$useEditab = _this$props.useEditableKey,
          useEditableKey = _this$props$useEditab === void 0 ? false : _this$props$useEditab;
      var formStructure = form || {
        fields: fields
      } || {
        fields: []
      };
      var formVisibility = formStructure && (0, _formVisibilityHelper.default)(formStructure.fields, fieldValues, replaceFieldNames);
      return /*#__PURE__*/_react.default.createElement(_layout.default, {
        formStructure: formStructure,
        formVisibility: formVisibility,
        showTitle: showTitle,
        account: account,
        components: components,
        defaultMessages: defaultMessages,
        formClasses: formClasses,
        fieldClasses: fieldClasses,
        FieldComponent: FieldComponent,
        replaceFieldNames: replaceFieldNames,
        FeedbackIcon: FeedbackIcon,
        disableAllFields: disableAllFields,
        fieldTypeProps: fieldTypeProps,
        ignoreVisibility: ignoreVisibility,
        useEditableKey: useEditableKey
      });
    }
  }]);

  return FormContainer;
}(_react.PureComponent);

FormContainer.propTypes = _formTypes.FormContainerTypes;
var _default = FormContainer;
exports.default = _default;